export const SiteAdditionalFilterRule = {
    toString: (value) => {
        return JSON.stringify(value);
    },
    parse: (value) => {
        return value ? JSON.parse(value)  : null;
    }
};
